import * as React from "react"


export default function pageCategoryColumn() {
    return {
        name: 'pageCategory', label: 'Mono/Multi Brand',
        options: {
            setCellHeaderProps: () => ({ sx: { textAlign: 'center' } }),
            setCellProps: () => ({ sx: { textAlign: "center", fontSize: '0.875rem' } }),
        }
    }
}